import { gql } from '@apollo/client';

export const PUBLISH_MONITORINGFORM = gql`
  mutation PublishMonitoringForm($id: ID!) {
    monitoringForm: publishMonitoringForm(id: $id) {
      id
      published
    }
  }
`;
